import {useState, useEffect} from 'react';
import { FormGroup, Label } from 'reactstrap'
import Editor from 'react-simple-wysiwyg';

import { isNull } from '../../izUtils';
import DisplayHistory from '../../helpers/DisplayHistory';

const Wysiwyg = ({data, /*onChange,*/ onBlur, showErrors, history}) => {
    const { name, display, errors, title, disabled, mandatory} = data;

    const [value, setValue] = useState("my <b>HTML</b>");

    useEffect(() => {
        setValue(data.value === null ? '' : data.value);
    }, [data.value]);

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    if (display) {
        return (
            <FormGroup className={(data.name === 'reject_message') ? 'red-alert' : ''}>
                <Label>{title + (mandatory ? " *" : "")}</Label>
                <Editor
                    name={name}
                    value={value}
                    onChange={handleChange}
                    onBlur={() => isNull(onBlur) ? {} : onBlur(value, name)}
                    disabled={disabled}
                />
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
                {(!isNull(history) && history.length > 0) && <DisplayHistory history={history} data={data} />}
            </FormGroup>
        )
    } else {
        return null;
    }
}

export default Wysiwyg